<template>
  <div>

    <v-navigation-drawer v-model="drawer" app :clipped="!is_mobile" :permanent="!is_mobile" color="blue-grey lighten-5" expand-on-hover >
      <v-list dense class="py-1" shaped >
        <v-list-item two-line to="/profile" color="primary">
          <v-list-item-avatar>
            <v-icon large>mdi-account-circle</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{oneUser.name? oneUser.name : "Usuário"}}</v-list-item-title>
            <!-- <v-list-item-subtitle>cargo</v-list-item-subtitle> -->
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-item-group color="primary">

          <v-list-item v-for="(item,idx) in items" :key="item.title+idx" link :to="item.path"  :disabled="item.disabled">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar :collapse-on-scroll="is_mobile" color="primary" dark ref="myAppBar" app clipped-left>
      <v-app-bar-nav-icon class="hidden-md-and-up"  @click="drawer = !drawer"></v-app-bar-nav-icon>
      <!-- <v-icon class="hidden-sm-and-down mr-4">mdi-chart-donut-variant</v-icon> -->
      <router-link to="/" >
        <v-avatar color="white" class="mr-4" size="48">
          <v-img contain src="https://www.escritorioadvocacia.org/imgempresas/gazzinelli-consultoria-18009-gYh5.jpg"></v-img>
        </v-avatar>
      </router-link>
      <v-toolbar-title>GC - Clientes</v-toolbar-title>

      <v-spacer></v-spacer>

      <template v-if="!is_mobile && false">
        <!-- normal buttons -->
        <!-- not so good -->
        <v-btn text color="white"> text</v-btn>
      </template>
      <v-toolbar-items v-if="false && !is_mobile" class="hidden-sm-and-down mr-4">
        <!-- block buttons -->
        <v-btn text color="white" v-for="(item, idx) in items" :key="'btn'+idx" :to="item.path"> {{item.title}}</v-btn>
      </v-toolbar-items>

      <!-- <v-btn class="hidden-md-and-up" icon color="white" to="/"><v-icon>mdi-home</v-icon></v-btn> -->
    </v-app-bar>

    


    <v-bottom-navigation v-model="bottomNav" app shift bottom fixed grow class="hidden-md-and-up mt-5">
      <v-btn active-class="primary--text" to="/clients">
        <span>Clientes</span>
        <v-icon>mdi-star</v-icon>
      </v-btn>

      <v-btn disabled active-class="primary--text" to="/litigations">
        <span>Processos</span>
        <v-icon>mdi-file-cabinet</v-icon>
      </v-btn>

      <v-btn disabled active-class="primary--text" to="/financials">
        <span>Financeiro</span>
        <v-icon>mdi-currency-usd</v-icon>
      </v-btn>

      <v-btn disabled active-class="primary--text" to="/dashboard">
        <span>Relatórios</span>
        <v-icon>mdi-finance</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  data() {
    return {
      drawer: false,
      bottomNav:false,
      items: [
        { title: 'Clientes',          path: '/clients', icon: 'mdi-star', disabled: false},
        { title: 'Processos',           path: '/litigations', icon: 'mdi-file-cabinet', disabled: true },
        { title: 'Fluxo Financeiro',  path: '/financials', icon: 'mdi-currency-usd', disabled: true},
        { title: 'Fornecedores',        path: '/suppliers', icon: 'mdi-account-tie' , disabled: false},
        { title: 'Relatórios',        path: '/dashboard', icon: 'mdi-finance', disabled: false },
        { title: 'Configurações',       path: '/settings', icon: 'mdi-settings' },
        { title: 'Sair',                path: '/logout', icon: 'mdi-logout' },
      ],
    }
  },
  computed: {
    isCollapsed() {
      let app_bar_collapsed = this.$refs.myAppBar? this.$refs.myAppBar.isCollapsed : false
      return this.$refs.myAppBar? this.$refs.myAppBar.isCollapsed : false
    },
    is_mobile() {
      return document.body.clientWidth < 720
    },
    ...mapState({
      oneUser: state => state.User.oneUser,
    })
  },
}
</script>

<style lang="scss" scoped>

</style>